import { render, staticRenderFns } from "./SeguimientoSubTab.vue?vue&type=template&id=9b973c86&"
import script from "./SeguimientoSubTab.vue?vue&type=script&lang=js&"
export * from "./SeguimientoSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports